module.exports = __webpack_public_path__ + "img/9.b04f09b5.png";